/** 用户信息管理的请求方法 */
import http from '@/api/index'
import { DbUser } from '@/api/interface/dbUser.model'
import { PORT1 } from '../config/servicePort'

export class DbUserServer {
  /** 获取用户信息 */
  static getUserinfo() {
    return http.get<DbUser.DbUserinfo>(PORT1 + 'user/online')
  }

  /** 获取用户个人资料信息 */
  static getPersonalInfo(id: number) {
    return http.get<DbUser.PersonalInfoRes>(PORT1 + `users/show/${id}`)
  }

  /** 后台用户个人资料 */
  static changePersonalInfo(params: DbUser.DbPersonalInfoReq, id: number) {
    return http.put(PORT1 + `users/update/${id}`, params)
  }

  /**修改密码 */
  static changePasswordInfo(params: DbUser.ChangePasswordReq) {
    return http.post(PORT1 + 'users/changepassword', params)
  }

  /** 修改后台用户背景图或头像 */
  static changeAvatarOrBack(params: DbUser.ChangeBackOrAvatar, id: number) {
    return http.post(PORT1 + `users/singUpdate/${id}`, params)
  }
}
